import {useEffect, useState} from "react";
import {ContactTypeFilterUserData} from "../../../../types/ContactTypeFilter";
import {ContactTypeView} from "../../../../types/ContactType";
import {useRestClient} from "../../../../client/SpmRestClient";

export type ContactFilterTableRowProps = {
	filter: ContactTypeFilterUserData;
	active: boolean;
	onClick: (filter: ContactTypeFilterUserData) => any;
	onDoubleClick: (filter: ContactTypeFilterUserData) => any;
}

export default function ContactFilterTableRow({filter, active, onClick, onDoubleClick}: ContactFilterTableRowProps) {
	const restClient = useRestClient();
	const [contactType, setContactType] = useState<ContactTypeView>();

	useEffect(
		() => {
			restClient.contactTypes
				.load(filter.contactTypeId)
				.then(setContactType)
		},
		[filter]
	);

	return <tr
		className={active ? 'active' : ''}
		onClick={() => onClick(filter)}
		onDoubleClick={() => onDoubleClick(filter)}
	>
		<td className="no-select">{contactType?.source.name}</td>
		<td className="no-select">{contactType?.name}</td>
		<td className="no-select">{filter.targetGroups.map((g) => 'o')}</td>
	</tr>
}
